import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import queryString from 'query-string';

import Layout from '../../ui/Layout';
import PasswordResetForm from './PasswordResetForm';
import fetchDux from '../../../state/fetch-dux';

const getRandomImage = images => {
  if (!images || !images.length) return null;
  const min = 0;
  const max = (images || []).length - 1;
  const index = Math.floor(Math.random() * (max - min + 1)) + min;
  return (images[index] || {}).href;
};

class ClientPasswordReset extends Component {
  constructor(props) {
    super(props);
    this.state = { isPreview: false };
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    const qs = queryString.parse(this.props.location.search) || {};
    this.props.getContent({
      page: 'client-login', // we can use the same content route as for login
      preview: qs.preview
    });
    this.setState({ isPreview: !!qs.preview });
  }
  componentWillUnmount() {
    const { clearGetContent, clearSubmit } = this.props;
    clearGetContent();
    clearSubmit();
  }
  render() {
    const { content, submitForm, error, result, match } = this.props;
    const { data, versionName } = content || {};
    const { image } = data || {};
    const { isPreview } = this.state;
    const href = getRandomImage(image);
    const handleSubmit = values => {
      const { password } = values || {};
      const { token } = match.params || {};
      submitForm({ token, password });
    };
    return (
      <Layout
        route="client-password-reset"
        isPreview={isPreview}
        versionName={versionName}
      >
        <main>

          <section style={{ backgroundImage: `url(${href})` }}>
            <div className="text left">Napa Valley, CA</div>
            <div className="text right">we measure phenolics</div>
            <Link className="link" to="/">
              Back
            </Link>
            <Link className="brand" to="/" />
            {!result &&
              <PasswordResetForm
                onSubmit={handleSubmit}
                message={error && error.message}
              />}
            {result &&
              <div className="confirmation">
                Password reset successfully.<br />
                <Link className="link" to="/client-login">
                  Return to Login
                </Link>
              </div>}
          </section>

        </main>
      </Layout>
    );
  }
}

const mapState = state => {
  const { result: content } = state.getContent.toJS();
  const { error, inProgress, result } = state.resetPassword.toJS();
  return { content, error, inProgress, result };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      submitForm: fetchDux.resetPassword.createAction,
      clearSubmit: fetchDux.resetPassword.clearAction,
      getContent: fetchDux.getContent.createAction,
      clearGetContent: fetchDux.getContent.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ClientPasswordReset);



// WEBPACK FOOTER //
// ./src/components/routes/clientPasswordReset/PasswordReset.js